<template>
  <div class="identity ba-flex md:ba-items-center ba-pt-16 md:ba-pt-32">
    <div
      class="container ba-flex ba-justify-center ba-flex-wrap ba-py-10 ba-content-center md:ba-content-start"
    >
      <vis-login-header />
      <main
        class="identity__wrap ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start"
      >
        <div class="md:ba-relative md:ba-z-50 md:ba-w-full md:ba-h-full md:ba-overflow-y-auto ba-py-16 md:ba-py-32">
          <!--<figure class="ba-hidden md:ba-flex ba-mb-12">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 36.42" class="ba-w-48 ba-mx-auto">
              <path
                d="M16 0v3.9l-16 .16v28.94l16-.16v3.62l27-4.36v-5.23h-.85v3.31h-2.14v-3.28h-1.83v-1.9h1.82v-8.66h-1.83v-1.87h1.83v-3.47h2.14v3.46h.86v-10.23zm0 25h-1.41v-3.1h1.45zm-14.51 6.51v-25.67l14.51-.15v15.72h-3.5v-2.2h2.88v-3.1l-6.32.06v1.3h-2.44v-2.64l6.18-.06a.25.25 0 0 0 .21-.14v-3.63a.21.21 0 0 0-.2-.18h-4.24v-1.59l-6.32.06v3.11l6.32-.07v-1.08h4v3l-6.12.06a.25.25 0 0 0-.24.22v3.16a.25.25 0 0 0 .22.25l2.67.06v1.32h3v2.2l-6 .06a.25.25 0 0 0-.24.26v3.4h-1.21v3.1l6.35-.11v-1.23h1.3v1.19h3.77v3.27zm4.83-6.34v-3.17l7.81-.08v3.08h-1.86v1.44h-1.27v-1.31zm24.48 6.41h-2.17l-11-26.82 2.4.1 9.43 23.73h.4l8.77-22.88 2.4.15zM42.15 24.99l.85-.01v-8.66h-.85v8.67z"
              />
            </svg>
          </figure>-->
          <img
            v-if="false"
            src="/img/rhombus.svg"
            class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba-right-10 xl:ba--right-1/12"
          />
          <img
            v-if="false"
            src="/img/stairs.svg"
            class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba--left-1/6"
          />
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import VisLoginHeader from "./vis-login-header";

export default {
  name: "vis-login-layout",
  components: {
    VisLoginHeader
  }
};
</script>
